module.exports = __webpack_public_path__ + "static/7-cd4a4e3992b5aa60c99d05c40df11a05.jpg";